
// @ts-nocheck



import { i18nText } from '@/locales';

import { LoyaltySubscriptionAddRequestType } from './loyaltySubscription.types';
export class loyaltySubscriptionForm {
    public id?: number | null;
    public salon_id?: number | null;
    phone: number | null;
    membership_number: number | null;
    discount: number | null;
    client_id: number | null;
    membership_type_id: number | null;
    total_sum: number | null

    proceed_payment: boolean;
    cashbox_id: number | null
    cashbox_sum: number | null

    setFormData(data: LoyaltySubscriptionAddRequestType): void {
        this.id = data.id;
        this.salon_id = data.salon_id;
        this.phone = data.phone;
        this.membership_number = data.membership_number;
        this.discount = data.discount;
        this.client_id = data.client_id;
        this.membership_type_id = data.membership_type_id;
        this.validity = data.validity;
        this.total_sum = data.total_sum

        this.proceed_payment = data.proceed_payment;
        this.cashbox_id = data.cashbox_id
        this.cashbox_sum = data.cashbox_sum
    }
    constructor() {
        this.salon_id = null;
        this.salon_id = null;
        this.phone = null;
        this.membership_number = null;
        this.discount = null;
        this.client_id = null;
        this.membership_type_id = null;
        this.total_sum = null
        this.cashbox_id = null
        this.cashbox_sum = null
        this.proceed_payment = false
        this.validity = null
    }
}
export const FormRules = {
    membership_type_id: [{ required: true, message: i18nText("Укажите тип абоненмента"), trigger: 'change' }],
    client_id: [{ required: true, message: i18nText("Укажите клиента"), trigger: 'change' }],
    discount: [
        { required: true, message: i18nText("Укажите размер скидки"), trigger: 'change' },
    {min: 0, max: 100, message: i18nText("Нужно указать от 0 до 100 скидки."), trigger: 'change', type: 'number'},],
    cashbox_id: [{ required: true, message: i18nText("Укажите кассу"), trigger: 'change' }],
    cashbox_sum: [{ required: true, message: i18nText("Укажите сумму"), trigger: 'change' }]
};
